import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { PainPoints } from "@/components/landing/PainPoints";
import { Services } from "@/components/landing/Services";
import { Comparison } from "@/components/landing/Comparison";
import { Audience } from "@/components/landing/Audience";
import { Vision } from "@/components/landing/Vision";
import { WhyOperator } from "@/components/landing/WhyOperator";
import { Growth } from "@/components/landing/Growth";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { LeadForm } from "@/components/landing/LeadForm";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { FloatingCTA } from "@/components/landing/FloatingCTA";

export default function Landing() {
  return (
    <div className="bg-[#050505] text-white">
      <Header />
      <main className="pb-16 md:pb-0">
        <Hero />
        <PainPoints />
        <Services />
        <Comparison />
        <Audience />
        <Vision />
        <WhyOperator />
        <Growth />
        <HowItWorks />
        <LeadForm />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
